import { connect } from 'react-redux';
import ReferralCloseDialog from '../../../components/Referrals/ReferralCloseDialog/ReferralCloseDialog';
import { closeReferral, getReferral, getCloseDateRange } from '../../../actions/entities';

const mapStateToProps = ({ entities: { referrals } }) => ({
  referralCloseDateRange: referrals.previewed.closeDateRange.referralCloseDateRange,
  isFetching: referrals.previewed.closeDateRange.isFetchingDateRange,
  errorMessage: referrals.previewed.closeDateRange.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  closeReferral: referralData => dispatch(closeReferral(referralData)),
  getReferralCloseDateRange: referralId => dispatch(getCloseDateRange(referralId)),
  getReferral: referralId => dispatch(getReferral(referralId)),
});

const ReferralCreatePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReferralCloseDialog);

export default ReferralCreatePage;
